import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export const FAQ: React.FC = () => {
  const faqs = [{
    q: '¿Qué recibo exactamente cuando compro?',
    a: 'Recibes un PDF descargable y un Audio de entrenamiento enviados a tu correo en menos de 5 minutos. Puedes leerlos y escucharlos desde tu celular inmediatamente.'
  }, {
    q: '¿Me sirve si ya me negaron la visa antes?',
    a: 'Sí. Incluimos un módulo específico para revertir la percepción negativa de rechazos previos ante el oficial.'
  }, {
    q: '¿Me sirve si gano poco dinero o soy independiente?',
    a: 'Sí. El Método MRA se enfoca en la claridad y la certeza de comunicación, no en demostrar riqueza.'
  }, {
    q: '¿Qué pasa si no me funciona?',
    a: 'Tienes 7 días de garantía total. Si sientes que el protocolo no te preparó como esperabas, te devolvemos el 100% de tu dinero sin preguntas.'
  }, {
    q: '¿Es difícil de aprender?',
    a: 'No. Está diseñado para ser consumido y aplicado en una tarde. Incluso si tu cita es mañana.'
  }];
  return <SectionWrapper className="bg-navy-light/30" data-id="element-30">
      <div className="max-w-3xl mx-auto" data-id="element-31">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-10 text-center" data-id="element-32">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-6" data-id="element-33">
          {faqs.map((faq, index) => <div key={index} className="bg-navy p-6 md:p-8 rounded-xl border border-gray-800" data-id="element-34">
              <h3 className="text-xl font-bold text-gold mb-3 flex items-start gap-3" data-id="element-35">
                <span className="shrink-0 mt-1" data-id="element-36">❓</span>
                <span data-id="element-37">{faq.q}</span>
              </h3>
              <p className="text-lg text-white flex items-start gap-3 pl-[2.25rem]" data-id="element-38">
                <span className="shrink-0 mt-1 hidden md:inline-block" data-id="element-39">✅</span>
                <span data-id="element-40">{faq.a}</span>
              </p>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
};